<template>
  <div class="table" ref="table">
    <!-- <div class="left" ref="left" :class="shadow && 'shoadow'">
      <div class="l-i row" v-for="item in leftColumn" :key="item">{{ item }}</div>
    </div>-->
    <div class="right">
      <div
        class="r-i"
        :class="column[index].key"
        v-for="(item , index) in rightColumn"
        :key="index"
      >
        <div class="r-i-i row" v-for="(_item,_index) in item" :key="_index">{{ _item}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    column: {
      type: Array,
      default: []
    },
    dataSource: {
      type: Array,
      default: []
    },
    top: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      leftColumn: [],
      rightColumn: [],
      shadow: false
    };
  },

  watch: {
    dataSource(v) {
      if (v && v.length) {
        this.coculation();
      }
    },

    top(v) {
      this.$refs.left.scrollTop = v;
    }
  },

  methods: {
    coculation() {
      // let col = [];
      let column = [...this.column];
      // let leftCol = column.shift();
      // let tit = leftCol.title;
      let rightCol = [];
      // col.push(tit);
      // this.dataSource.map(item => {
      //   col.push(item[leftCol.dataIndex]);
      // });
      // this.leftColumn = [...col];
      column.map(item => {
        let arr = [];
        arr.push(item.title);
        this.dataSource.map(_item => {
          if (item.key === 'signal') {
            arr.push(_item[item.key] ? _item[item.key] + 'dbm' : '无');
          } else if (item.key === 'voltage') {
            arr.push(_item[item.key] ? _item[item.key] + 'v' : '无');
          } else if (item.key === 'state') {
            arr.push(_item[item.key] ? '开' : '关');
          } else {
            arr.push(_item[item.key] ? _item[item.key] : '无');
          }
        });
        rightCol.push(arr);
      });
      this.rightColumn = [...rightCol];
    },

    handleTableScroll(e) {
      let v = this.$refs.table.scrollLeft;
      if (v > 0) {
        this.shadow = true;
      } else {
        this.shadow = false;
      }
    },

    handleLeftScroll(e) {
      let top = this.$refs.left.scrollTop;
      this.$emit('cb', top);
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  font-size: 14px;
  height: 100%;
  overflow-x: scroll !important;
}

.left {
  // position: fixed;
  display: inline-block;
  padding: 0 14px;
  overflow-x: hidden;
  // overflow-y: scroll;
  z-index: 1000;
  background: #ffffff;
  max-width: 120px;
  height: 100%;
}

.shoadow {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}

.right {
  display: inline-block;
  vertical-align: top;
  min-width: calc(100% + 290px);

  .r-i {
    display: inline-block;
    padding: 0 14px;

    .r-i-i {
      // display: inline-block;
    }
  }
}

.row {
  height: 40px;
  line-height: 40px;
}

.signal {
  width: 60px;
}

.voltage {
  width: 40px;
}
</style>
